import { combineReducers } from 'redux'
import { LoginReducer } from "./loginReducer";
import { PracticeUserReducer } from "./practiceUserReducer";
import { AppointmentsReducer } from './appointmentsReducer';
import { PatientReducer } from './patientReducer';
import { ChatReducer } from './chatReducer';
import { SettingsReducer } from './settingsReducer';
import { systemConstantsReducer } from "../reducers/systemConstantsReducer";


const rootReducer = combineReducers({
    // Define a top-level state field named `todos`, handled by `todosReducer`
    loginDetails: LoginReducer,
    practiceDetails: PracticeUserReducer,
    appointmentDetails: AppointmentsReducer,
    patientDetails: PatientReducer,
    chatDetails: ChatReducer,
    settingsDetails: SettingsReducer,
    systemConstants: systemConstantsReducer
  })
  
export default rootReducer;


